import script from "./BackEndOssUpload.vue?vue&type=script&lang=ts&setup=true"
export * from "./BackEndOssUpload.vue?vue&type=script&lang=ts&setup=true"

import "./BackEndOssUpload.vue?vue&type=style&index=0&id=e252c23e&lang=less"

const __exports__ = script;

export default __exports__